import React from 'react'
import L from 'react-loadable'
import { Icon } from 'semantic-ui-react'

const Loading = () => (
    <div style={{ height: '100vh', lineHeight: 50, textAlign: 'center', verticalAlign: 'middle' }}>
        <Icon loading name='spinner' size='massive' />
    </div>
)

export default opts => L({
    loading: Loading,
    ...opts
})


// WEBPACK FOOTER //
// ./src/display/features/ui/components/Loadable.js